<template>
<div class="animated fadeIn">
  <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
    <b-row style="min-width: 1200px;">
      <b-col sm="3">
        <div style="margin-top:-7px;">
          <span class="card-title wise-card-header">예산안 최적화 결과</span>
        </div>
        <div class="wise-small-header">Budget Allocation Result</div>
      </b-col>
      <b-col sm="3" class="brief">
        <div class="wise-small-header">캠페인 타이틀</div>
        <div><b>{{constFormData.campaignTitle}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">총 예산 (백만원)</div>
        <div><b>{{constFormData.totalBudgetStr}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">최적화 모드</div>
        <div><b>채널 예산안 최적화</b></div>
        <div><b>Max Reach Mode</b></div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-success" class="btn-pill" @click="backtoForm()">
            <span style="font-weight:900;">입력 화면</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-primary" class="btn-pill" @click="excelDown()">
            <span style="font-weight:900;">엑셀 다운</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="12">
        <div style="padding-top:10px;font-size:12px;color:grey;font-weight:bold;text-align:center">
          광고효과예측솔루션은 미디어 계획에 대한 예상치를 제공할 수 있지만 특정 실적이나 결과를 보장하지는 않습니다.
          계획의 실제 실적은 광고 품질 등의 다양한 요인에 따라 달라질 수 있습니다.
        </div>
      </b-col>
      <b-collapse id="collapse1" class="mt-2" style="width:98%">
        <hr>
        <!-- <p class="card-text">{{formData}}</p> -->
        <b-row>
          <b-col sm=1></b-col>
          <b-col sm=10>
            <table style="border-color:transparent;width:100%">
              <thead>
                <tr class="wise-small-header">
                  <th >시뮬레이션 타이틀</th>
                  <th >광고주</th>
                  <th >대행사</th>
                  <th >업종</th>
                  <th >타겟</th>
                  <th v-if="formData.montlyAllocation">월배분1</th>
                  <th v-if="formData.montlyAllocation">월배분2</th>
                  <th v-if="formData.montlyAllocation">월배분3</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>{{constFormData.simulationTitle}}</b></td>
                  <td><b>{{constFormData.advertiger.advt_NM}}</b></td>
                  <td><b>{{constFormData.agency.agc_NM}}</b></td>
                  <td><b>{{constFormData.industry.indt_NM}}</b></td>
                  <td><b>{{constFormData.targetCode}}</b></td>
                  <td v-if="formData.montlyAllocation"><b>{{constFormData.monthly1}}</b></td>
                  <td v-if="formData.montlyAllocation"><b>{{constFormData.monthly2}}</b></td>
                  <td v-if="formData.montlyAllocation"><b>{{constFormData.monthly3}}</b></td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col sm=1></b-col>
        </b-row>
        <!-- <hr> -->
        <b-row style="padding-top:20px;">
          <b-col sm=1></b-col>
          <b-col sm=10>
            <b-table bordered hover :items="constFormData.channelListResult" :fields="mediaListFields"></b-table>
          </b-col>
          <b-col sm=1></b-col>
        </b-row>
      </b-collapse>
    </b-row>
    <div slot="footer" v-b-toggle.collapse1 variant="primary" style="text-align:center"><b>예산안 최적화 정보 상세보기</b></div>
  </b-card>
  <b-card style="height:450px" class="bs-callout bs-callout-primary panelScrollBar">
      <!-- <resize-observer @notify="handleResize" /> -->
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:35px;">
          <b-col sm="6">
            <span class="float-left card-title wise-card-title">채널 목표 도달율 </span>
            <budgetHelpResult01></budgetHelpResult01>
            <budgetHelpResult02></budgetHelpResult02>
            <span class="float-right" style="padding-right:15px;" v-if="constFormData.montlyAllocation&&constFormData.monthly3>0">
              <b-button id="monthlyBtn3" block variant="outline-success" class="btn-pill" @click="budgetChange(3)">
                <span style="font-weight:900;">월배분3</span>
              </b-button>
            </span>
            <span class="float-right" style="padding-right:15px;" v-if="constFormData.montlyAllocation">
              <b-button id="monthlyBtn2" block variant="outline-success" class="btn-pill" @click="budgetChange(2)">
                <span style="font-weight:900;">월배분2</span>
              </b-button>
            </span>
            <span class="float-right" style="padding-right:15px;" v-if="constFormData.montlyAllocation">
              <b-button id="monthlyBtn1" block variant="outline-success" class="btn-pill active" @click="budgetChange(1)">
                <span style="font-weight:900;">월배분1</span>
              </b-button>
            </span>
            <br/>
            <b-col sm="12">
              <br/>
              <b-row>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult.totalReach1}}%</div>
                    <div>Reach</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult.totalBudget | separator}}</div>
                    <div>Budget</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult.af}}</div>
                    <div>A.F</div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-table bordered hover :items="resultList" :fields="resultListFields"></b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
          <b-col v-if="!showResult" sm="6" >
            <loading></loading>
          </b-col>
          <b-col v-show="showResult" sm="6" >
            <div  id="channelReachChartdiv" class="CSSAnimationChart"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card style="height:620px" class="bs-callout bs-callout-primary panelScrollBar">
        <!-- <resize-observer @notify="handleResize" /> -->
        <div style="min-width: 1200px;">
          <b-row style="padding-bottom:35px;">
            <b-col sm="12">
              <span class="card-title wise-card-title">채널 목표 도달율 </span>
              <span class="small text-muted wise-card-subtitle"> Least Budget Mode</span>
            </b-col>
            <b-col sm="6" >
              <br />
              <b-table id="topResultTable" :busy.sync="isBusy" ref="table" bordered hover :items="topResultList"
                  :fields="topResultListFields"
                  @row-clicked="myRowClickHandler"
                  class="table-fixed">
              </b-table>
            </b-col>
            <b-col sm="6" >
              <br />
              <b-row>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult2.totalReach1}}%</div>
                    <div>Reach</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult2.totalBudget | separator}}</div>
                    <div>Budget</div>
                  </b-card>
                </b-col>
                <b-col sm="4">
                  <b-card class="text-white bg-primary">
                    <div class="h4 m-0">{{simulationResult2.af}}</div>
                    <div>A.F</div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-table bordered hover :items="resultList2" :fields="resultListFields"></b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-card>
</div>
</template>


<script>
import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import light from "../../custom/amcharts/themes/light.js";
import pie from "../../custom/amcharts/pie.js";
import reachFormData from "../common/ReachFormData.js";
import reachLogic from "../common/ReachLogic.js";
import channelReachResultChart from "./channelReachResultChart.js";
import numeral from 'numeral';
import loading from '../common/blockLoading.vue'; // 로딩중
import targetPortionUtils from "../common/targetPortionUtils.js";
import leftSideUtil from "../common/LeftSideUtil.js"

import budgetHelpResult01 from "../helpModals/budget/budgetHelpResult01.vue";
import budgetHelpResult02 from "../helpModals/budget/budgetHelpResult02.vue";

const moment = require("moment");
import swal from 'sweetalert2';
export default {
  components: {
    budgetHelpResult01,
    budgetHelpResult02,
    loading
  },
  data(){
    return {
      showResult : false,
      isBusy: false,
      mediaListFields: [
        {
          key: 'media',
          label: '미디어',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'channel',
          label: '채널',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'cpm',
          label: 'CPM',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        }
      ],
      mediaListFields2th: [
        {
          key: 'media',
          label: '미디어',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'channel',
          label: '채널',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'cpm',
          label: 'CPM',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'minmumAllocationPortion',
          label: '할당비율',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'portionComparator',
          label: '부등호',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
      ],
      resultListFields: [
        {
          key: 'channel',
          label: 'channel',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budgetRatio',
          label: '배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'budget',
          label: 'budget',
          formatter: (value) => { return numeral(value).format('0,0') },
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'grps',
          label: 'grps',
          formatter: (value) => { return numeral(value).format('0,0.00') },
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'reach1',
          label: 'reach1',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'af',
          label: 'A.F',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
      ],
      topResultListFields: [
        {
          key: 'rank',
          label: 'RANK',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'media1Index',
          label: 'channel1 배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'media2Index',
          label: 'channel2 배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'media3Index',
          label: 'channel3 배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'totalReach1',
          label: 'totalReach',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
      ],
      topResultList2Fields: [
        {
          key: 'rank',
          label: 'RANK',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'media1Index',
          label: 'channel1 배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'media2Index',
          label: 'channel2 배분비율',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
        {
          key: 'totalReach1',
          label: 'totalReach',
          thClass: 'detailTableTHClass',
          tdClass: 'detailTableTDClass',
        },
      ],
      constFormData: this.$session.get('budgetChannelInputFormData'),
      formData: this.$session.get('budgetChannelInputFormData'),
      allocationMediaList:[],
      totalBudget:0,
      inte_cffcnt : this.$session.get('inte_cffcnt'),
      inteMedia:{
          tvMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            resultMedia:null,
            screenCount: 1,
          },
          mobileMedia :{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          pcMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          digitalMedia:{
            inte_ModelCode:'',
            overall:null,
            mediaList: {},
            etcMediaList:[],
            resultMedia:null,
            screenCount: 1,
          },
          totalMedia:{
            resultMedia:null,
          },
      },
      // gaData : {}
      simulationResult:{},
      simulationResult2:{},
      resultList:[],
      resultList2:[],
      topResultList:[],
      nScreen:2,
      selectedMontlyBtn:'monthlyBtn1'
    }
  },
  created: function() {
  },
  updated: function(){
  },
  mounted: function() {
    this.showResult = false;

    leftSideUtil.highLightMenu('budgetCustomId8642');

    if(this.constFormData.allocationPortionON){
      this.mediaListFields = this.mediaListFields2th;
    }
    this.constFormData.totalBudget = this.constFormData.totalBudget * 1000000;
    this.formData.totalBudget = this.formData.totalBudget * 1000000;

    this.selectedMontlyBtn = "monthlyBtn1";
    this.allocationMediaList = [];
    // 월배분에 따라 totalBudget 변경하는 로직 만 반영
    if(this.constFormData.montlyAllocation){ // 마운트 시점에는 첫번째 달 월배분 반영
      this.totalBudget = this.constFormData.totalBudget * (this.constFormData.monthly1/100);
    }else{
      this.totalBudget = this.constFormData.totalBudget;
    }
    //  전체 프로세스 핸들링
    this.doBudgetAllocation();
  },
  methods: {
    backtoForm(){
      window.location.href = "#/budget/budget";
    },
    budgetChange(monthly){
      this.allocationMediaList = [];
      this.topResultList = [];
      this.simulationResult = {};
      this.simulationResult2 = {};
      this.resultList = [];
      this.resultList2 = [];
      // 월배분 변경시 totalBudget 값 변경
      switch (monthly) {
        case 1:
          document.getElementById(this.selectedMontlyBtn).className
          = document.getElementById(this.selectedMontlyBtn).className.replace("active", "");
          document.getElementById("monthlyBtn1").className += " active";
          this.selectedMontlyBtn = "monthlyBtn1";

          this.totalBudget = this.constFormData.totalBudget * (this.constFormData.monthly1/100);
          this.doBudgetAllocation();
          break;
        case 2:
          document.getElementById(this.selectedMontlyBtn).className
          = document.getElementById(this.selectedMontlyBtn).className.replace("active", "");
          document.getElementById("monthlyBtn2").className += " active";
          this.selectedMontlyBtn = "monthlyBtn2";

          this.totalBudget = this.constFormData.totalBudget * (this.constFormData.monthly2/100);
          this.doBudgetAllocation();
          break;
        case 3:
          document.getElementById(this.selectedMontlyBtn).className
          = document.getElementById(this.selectedMontlyBtn).className.replace("active", "");
          document.getElementById("monthlyBtn3").className += " active";
          this.selectedMontlyBtn = "monthlyBtn3";

          this.totalBudget = this.constFormData.totalBudget * (this.constFormData.monthly3/100);
          this.doBudgetAllocation();
          break;
        default:

      }
      this.$root.$emit('bv::refresh::table', 'topResultTable');
    },
    // 전체 프로세스 핸들링
    doBudgetAllocation(){
      this.$log.debug('doBudgetAllocation (전체 프로세스 핸들링 시작)');
      var nScreen = this.formData.channelListResult.length;
      this.$log.debug('doBudgetAllocation 채널수 : ' + nScreen);
      this.$log.debug('doBudgetAllocation 월배분 : ' + this.constFormData.montlyAllocation);
      this.$log.debug('doBudgetAllocation 최소예산 할당비율 : ' + this.constFormData.allocationPortionON);

      if(nScreen === 2){
        this.nScreen = 2;
        this.topResultListFields = this.topResultList2Fields;
        this.allocationBudget2Screen(); // 모든 경우의 수에 따른 예산 할당
      }else if(nScreen === 3){
        this.nScreen = 3;
        this.allocationBudget3Screen(); // 모든 경우의 수에 따른 예산 할당
      }

      var self = this;
      setTimeout(function() {
        // 리치 계산
        self.calculationNScreenGrpsReach(self.nScreen);
        // console.log(self.allocationMediaList[0]);
        self.allocationMediaList[0].totalBudget = self.totalBudget;

        // 탈출 조건 확인 , 결과를 화면에 표현하기위한 변수에 값 담기
        self.resultList = [];
        var result1 = {};
        result1.channel = self.allocationMediaList[0].channel1;
        result1.budget = self.allocationMediaList[0].media1Budget.toFixed(2);
        result1.grps = self.allocationMediaList[0].grps1;
        result1.reach1 = self.allocationMediaList[0].media1Reach1.toFixed(2);
        result1.af = self.allocationMediaList[0].af1.toFixed(2);
        result1.budgetRatio = self.allocationMediaList[0].media1Index;
        self.resultList.push(result1);

        var result2 = {};
        result2.channel = self.allocationMediaList[0].channel2;
        result2.budget = self.allocationMediaList[0].media2Budget.toFixed(2);
        result2.grps = self.allocationMediaList[0].grps2;
        result2.reach1 = self.allocationMediaList[0].media2Reach1.toFixed(2);
        result2.af = self.allocationMediaList[0].af2.toFixed(2);
        result2.budgetRatio = self.allocationMediaList[0].media2Index;
        self.resultList.push(result2);

        if(self.nScreen === 3){
          var result3 = {};
          result3.channel = self.allocationMediaList[0].channel3;
          result3.budget = self.allocationMediaList[0].media3Budget.toFixed(2);
          result3.grps = self.allocationMediaList[0].grps3;
          result3.reach1 = self.allocationMediaList[0].media3Reach1.toFixed(2);
          result3.af = self.allocationMediaList[0].af3.toFixed(2);
          result3.budgetRatio = self.allocationMediaList[0].media3Index;
          self.resultList.push(result3);
        }
        self.$log.debug('doBudgetAllocation resultList객체 값 : ', self.resultList);

        channelReachResultChart.drawChart(self.resultList);
        self.simulationResult = self.allocationMediaList[0];
        self.simulationResult.totalBudget = self.totalBudget;
        self.simulationResult.totalReach1 = self.simulationResult.totalReach1.toFixed(2);
        self.simulationResult.af = (self.simulationResult.grpsSum / self.simulationResult.totalReach1).toFixed(2);
        self.$log.debug('doBudgetAllocation simulationResult객체 값 : ', self.simulationResult);

        for(var i=0; i<10;i++){
          self.allocationMediaList[i].rank = i+1;
          self.allocationMediaList[i].totalReach1 = parseFloat(self.allocationMediaList[i].totalReach1).toFixed(2);
          self.topResultList.push(self.allocationMediaList[i]);
        }
        self.$log.debug('doBudgetAllocation topResultList객체 값 : ', self.topResultList);
      } ,1000);
      setTimeout(function() {
        self.selectFirstRow();
      }, 2000);

      this.$log.debug('doBudgetAllocation (전체 프로세스 핸들링 종료)');
    },
    // 채널이 3개 선택된 경우에 예산 할당
    allocationBudget3Screen(){
      this.$log.debug('allocationBudget3Screen 시작');
      for(var i=98; i>=1; i--){
        for(var j=1; j<=98; j++){
          if(i+j == 100 ){
            break;
          }
          for(var k=1; k<=98; k++){
            if(i+j+k > 100){
              break
            }else if(i+j+k == 100){
              var allocationModel={};
              allocationModel.media1Index = i;
              allocationModel.media2Index = j;
              allocationModel.media3Index = k;
              allocationModel.media1Budget = this.totalBudget * (i/100);
              allocationModel.media2Budget = this.totalBudget * (j/100);
              allocationModel.media3Budget = this.totalBudget * (k/100);

              if(this.constFormData.allocationPortionON){
                var valid1 = eval(this.constFormData.channelListResult[0].minmumAllocationPortion + this.constFormData.channelListResult[0].portionComparator + allocationModel.media1Index);
                var valid2 = eval(this.constFormData.channelListResult[1].minmumAllocationPortion + this.constFormData.channelListResult[1].portionComparator + allocationModel.media2Index);
                var valid3 = eval(this.constFormData.channelListResult[2].minmumAllocationPortion + this.constFormData.channelListResult[2].portionComparator + allocationModel.media3Index);
                if(valid1&&valid2&&valid3){ // 최소예산 할당금액보다 큰경우만 예산배분 리스트에 등록
                  this.allocationMediaList.push(allocationModel);
                }
              }else{
                this.allocationMediaList.push(allocationModel);
              }
            }
          }
        }
      }
      if(this.allocationMediaList.length == 0){
        swal({
          type: 'error',
          text: '할당비율을 수정하세요'
        }).then((result) => {
          this.backtoForm();
        })
      }
      this.$log.debug('allocationBudget3Screen 종료');
    },
    allocationBudget2Screen(){
      this.$log.debug('allocationBudget2Screen 시작');
      // 채널이 2개만 선택된 경우에 예산 할당
      for(var i=99; i>=1; i--){
        var allocationModel={};
        allocationModel.media1Index = i;
        allocationModel.media2Index = (100-i);
        allocationModel.media1Budget = this.totalBudget * (i/100);
        allocationModel.media2Budget = this.totalBudget * ((100-i)/100);

        if(this.constFormData.allocationPortionON){
          var valid1 = eval(this.constFormData.channelListResult[0].minmumAllocationPortion + this.constFormData.channelListResult[0].portionComparator + allocationModel.media1Index);
          var valid2 = eval(this.constFormData.channelListResult[1].minmumAllocationPortion + this.constFormData.channelListResult[1].portionComparator + allocationModel.media2Index);
          if(valid1&&valid2){ // 최소예산 할당금액보다 큰경우만 예산배분 리스트에 등록
            this.allocationMediaList.push(allocationModel);
          }
        }else{
          this.allocationMediaList.push(allocationModel);
        }
      }
      if(this.allocationMediaList.length == 0){
        swal({
          type: 'error',
          text: '할당비율을 수정하세요'
        }).then((result) => {
          this.backtoForm();
        })
      }
      this.$log.debug('allocationBudget2Screen 종료');
    },
    calculationNScreenGrpsReach(nScreen){
      this.$log.debug('calculationNScreenGrpsReach 시작');
      var portionList = new Map(); // 타겟 배분비율 로직 관련
      targetPortionUtils.getTargetPortionList(portionList); // 타겟 배분비율 로직 관련
      var outputGender = this.formData.gender; // 타겟 배분비율 로직 관련

      this.$log.debug('calculationNScreenGrpsReach 모든 예산배분 경우에 따른 GRPs Reach1 계산');
      for(var i=0; i <this.allocationMediaList.length; i++){
          var cpm1 = this.formData.channelListResult[0].cpm;
          var cpm2 = this.formData.channelListResult[1].cpm;

          var eImp1 = ((this.allocationMediaList[i].media1Budget) / cpm1 ) * 1000;
          var eImp2 = ((this.allocationMediaList[i].media2Budget) / cpm2 ) * 1000;

          // 타겟 배분비율 로직 [Start] , 채널1, 채널2
          var tmpEImp1 = ((this.allocationMediaList[i].media1Budget) / cpm1 ) * 1000;
          var tmpEImp2 = ((this.allocationMediaList[i].media2Budget) / cpm2 ) * 1000;
          var inputGender = this.formData.channelListResult[0].gender;
          var channel = this.formData.channelListResult[0].channel;
          if(channel != 'Facebook' && channel != 'Youtube' && channel != 'SMR' ){
            channel = this.formData.channelListResult[0].media;
          }
          // output타겟을 기준으로 예상노출량 다시 계산
          if(outputGender == inputGender){
            var tmpChannelGender = channel + '_' + outputGender;
            eImp1 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp1);
            eImp2 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp2);
          }else if(outputGender == 'MF'){
            // inputTarget의 Gender 활용
            var tmpChannelGender = channel + '_' + inputGender;
            eImp1 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp1);
            eImp2 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp2);
          }else if(inputGender == 'MF'){
            // outputTarget의 Gender 활용
            var tmpChannelGender = channel + '_' + outputGender;
            eImp1 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp1);
            eImp2 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp2);
          }else {
            // inputTarget과 outputTarget의 성별이 다른경우
          }
          // 타겟 배분비율 로직 [End] , 채널1, 채널2

          // 채널1과 채널2의 GRPs 구하기
          var grps1 = ((eImp1 / this.formData.demographic_cnt) * 100); // 배분비율이 적용된 OutputTarget으로 GRPs 계산
          var grps2 = ((eImp2 / this.formData.demographic_cnt) * 100); // 배분비율이 적용된 OutputTarget으로 GRPs 계산

          // 채널1과 채널2의 Reach 구하기
          var media1Reach1 = reachLogic.rgpReachCalc(this.formData.channelListResult[0], grps1);
          var media2Reach1 = reachLogic.rgpReachCalc(this.formData.channelListResult[1], grps2);

          // 결과값 담기
          this.formData.channelListResult[0].eImp = eImp1;
          this.formData.channelListResult[1].eImp = eImp2;

          this.formData.channelListResult[0].grps = grps1;
          this.formData.channelListResult[1].grps = grps2;

          this.formData.channelListResult[0].reach1 = media1Reach1;
          this.formData.channelListResult[1].reach1 = media2Reach1;

          this.formData.channelListResult[0].af = grps1/media1Reach1;
          this.formData.channelListResult[1].af = grps2/media2Reach1;

          /////////////////////////////////////////////////////////////////////////////
          this.allocationMediaList[i].media = this.formData.channelListResult[0].media;
          this.allocationMediaList[i].channel1 = this.formData.channelListResult[0].channel;
          this.allocationMediaList[i].channel2 = this.formData.channelListResult[1].channel;

          this.allocationMediaList[i].cpm1 = cpm1;
          this.allocationMediaList[i].cpm2 = cpm2;

          this.allocationMediaList[i].eImp1 = eImp1;
          this.allocationMediaList[i].eImp2 = eImp2;

          this.allocationMediaList[i].grps1 = grps1;
          this.allocationMediaList[i].grps2 = grps2;

          this.allocationMediaList[i].media1Reach1 = media1Reach1;
          this.allocationMediaList[i].media2Reach1 = media2Reach1;

          this.allocationMediaList[i].af1 = grps1/media1Reach1;
          this.allocationMediaList[i].af2 = grps2/media2Reach1;
          this.allocationMediaList[i].grpsSum = parseFloat(grps1)+parseFloat(grps2);

          /////////////////////////////////////////////////////////////////////////////
          if(nScreen === 3){
            var cpm3 = this.formData.channelListResult[2].cpm;
            var eImp3 = ((this.allocationMediaList[i].media3Budget) / cpm3 ) * 1000;
            // 타겟 배분비율 로직 [Start] , 채널3
            var tmpEImp3 = ((this.allocationMediaList[i].media3Budget) / cpm3 ) * 1000;
            if(outputGender == inputGender){
              var tmpChannelGender = channel + '_' + outputGender;
              eImp3 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp3);
            }else if(outputGender == 'MF'){
              // inputTarget의 Gender 활용
              var tmpChannelGender = channel + '_' + inputGender;
              eImp3 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp3);
            }else if(inputGender == 'MF'){
              // outputTarget의 Gender 활용
              var tmpChannelGender = channel + '_' + outputGender;
              eImp3 = this.calcOutputImpression(this.formData.channelListResult[0], tmpChannelGender, portionList, tmpEImp3);
            }else {
              // inputTarget과 outputTarget의 성별이 다른경우
            }
            // 타겟 배분비율 로직 [End], 채널3

            // 채널3의 GRPs 구하기
            var grps3 = ((eImp3 / this.formData.demographic_cnt) * 100); // 배분비율이 적용된 OutputTarget으로 GRPs 계산
            // 채널3의 리치 구하기
            var media3Reach1 = reachLogic.rgpReachCalc(this.formData.channelListResult[2], grps3);
            // 결과값 담기
            this.formData.channelListResult[2].eImp = eImp3;
            this.formData.channelListResult[2].grps = grps3;
            this.formData.channelListResult[2].reach1 = media3Reach1;
            this.formData.channelListResult[2].af = grps3/media3Reach1;
            this.allocationMediaList[i].channel3 = this.formData.channelListResult[2].channel;
            this.allocationMediaList[i].cpm3 = cpm3;
            this.allocationMediaList[i].eImp3 = eImp3;
            this.allocationMediaList[i].grps3 = grps3;
            this.allocationMediaList[i].media3Reach1 = media3Reach1;
            this.allocationMediaList[i].af3 = grps3/media3Reach1;
            this.allocationMediaList[i].grpsSum += parseFloat(grps3);
          }

          // 미디어-채널 분류(구분)
          var result = reachLogic.classifyMedia(this.formData.channelListResult, $.extend(true, {}, this.inteMedia));

          // Inte 리치 구하기 , 미디어는 하나 채널은 2개~3개
          if(result.tvMedia.inte_ModelCode != ""){
            reachLogic.calcTVMedia(result.tvMedia, this.inte_cffcnt);
            this.allocationMediaList[i].totalReach1 = result.tvMedia.resultMedia.reach1;
          }else if(result.pcMedia.inte_ModelCode != ""){
            reachLogic.calcDigitalMedia(result.pcMedia, this.inte_cffcnt);
            this.allocationMediaList[i].totalReach1 = result.pcMedia.resultMedia.reach1;
          }else if(result.mobileMedia.inte_ModelCode != ""){
            reachLogic.calcDigitalMedia(result.mobileMedia, this.inte_cffcnt);
            this.allocationMediaList[i].totalReach1 = result.mobileMedia.resultMedia.reach1;
          }else if(result.digitalMedia.inte_ModelCode != ""){
            reachLogic.calcDigitalMedia(result.digitalMedia, this.inte_cffcnt);
            this.allocationMediaList[i].totalReach1 = result.digitalMedia.resultMedia.reach1;
          }
      }

      // 소팅
      this.$log.debug('calculationNScreenGrpsReach 결과리스트 소팅')
      this.allocationMediaList = this.$_.sortBy(this.allocationMediaList, function(o) { return -o.totalReach1; })
      this.$log.debug('calculationNScreenGrpsReach 1순위 결과 : ', this.allocationMediaList[0])
      this.showResult = true;
      this.$log.debug('calculationNScreenGrpsReach 종료');
    },
    // 타겟팅 논타겟팅 관련
    calcOutputImpression(mediaResult, tmpChannelGender, portionList, eImp){
      var outputPortionSum = 0.0;
      var outputPortionList = portionList.get(tmpChannelGender);
      var intersectedCode = mediaResult.intersectedCode;
      for(var j=0; j< intersectedCode.length; j++){
        if(intersectedCode[j] == 1){
          outputPortionSum += outputPortionList[j].portion;
        }
      }
      // outputImpression 계산 : (e.Impression * outputPortion / inputPortion)
      return parseInt(
        parseFloat(eImp) * outputPortionSum / mediaResult.portionSum
      )
    },
    selectFirstRow(){
      // console.log('helelele');
      var first = $("#topResultTable>tbody>tr:first").trigger('click');
      // console.log(first);
      // $(first[0]).addClass('selectedActive');
      // $(first).trigger('click.tr');
    },
    myRowClickHandler(record, index, event) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      // console.log(event);
      if(event.isTrusted){
        $(event.path[1]).addClass('selectedActiveGrey').siblings().removeClass('selectedActiveGrey');
      }else{
        $(event.path[0]).addClass('selectedActiveGrey').siblings().removeClass('selectedActiveGrey');
      }
      // console.log(record); // This will be the item data for the row

      this.resultList2 = [];
      var result1 = {};
      result1.channel = record.channel1;
      result1.budget = record.media1Budget.toFixed(2);
      result1.grps = record.grps1;
      result1.reach1 = record.media1Reach1.toFixed(2);
      result1.af = record.af1.toFixed(2);
      result1.budgetRatio = record.media1Index;
      this.resultList2.push(result1);

      var result2 = {};
      result2.channel = record.channel2;
      result2.budget = record.media2Budget.toFixed(2);
      result2.grps = record.grps2;
      result2.reach1 = record.media2Reach1.toFixed(2);
      result2.af = record.af2.toFixed(2);
      result2.budgetRatio = record.media2Index;
      this.resultList2.push(result2);

      if(this.nScreen === 3){
        var result3 = {};
        result3.channel = record.channel3;
        result3.budget = record.media3Budget.toFixed(2);
        result3.grps = record.grps3;
        result3.reach1 = record.media3Reach1.toFixed(2);
        result3.af = record.af3.toFixed(2);
        result3.budgetRatio = record.media3Index;
        this.resultList2.push(result3);
      }

      this.simulationResult2.totalBudget = this.totalBudget;
      this.simulationResult2.totalReach1 = parseFloat(record.totalReach1).toFixed(2);
      this.simulationResult2.af = (record.grpsSum / record.totalReach1).toFixed(2);
    },
    excelDown(){
      // console.log(this.constFormData);
      // console.log(this.simulationResult);
      // console.log(this.resultList);
      var token = sessionStorage.getItem("myToken");
      var formdata = JSON.stringify(this.constFormData);
      var result = JSON.stringify(this.simulationResult);
      var channelList = JSON.stringify(this.resultList);
      var data = new FormData();
      data.append('formdata', formdata);
      data.append('result', result);
      data.append('channelList', channelList);
      // var param = '';
      var config = {
        responseType: 'blob'
      };
      // console.log('엑셀다운!!');
      this.$http.post('/excel/channelBudgetResultDown',data,config)
        .then((result) => {
          // console.log(result);
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = this.constFormData.campaignTitle.replace(/ /gi, '');
          fileName = fileName + "_채널예산안최적화_" + moment().format('YYYYMMDD') ;
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  }
}
</script>

<style scoped>
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 400px
}
</style>
<style>
.table-wrapper-scroll-y {
  display: block;
  max-height: 550px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>



// WEBPACK FOOTER //
// src/views/budget/ChannelBudgetResult.vue